
import DashboardRoute from './Dashboard/Routes';
import LiquidationsRoute from './Liquidations/Routes';

const CommissionsRoute = [
    DashboardRoute,
    LiquidationsRoute
]

export default CommissionsRoute